import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Facebook, Instagram, Phone, Youtube, List } from 'react-feather';
import { Dropdown, Layout, Menu } from 'antd';
import logoMin from '@/assets/images/Logo-UC-mobile.png';

import logo from '@/assets/images/Logo_Footer.png';

import './style.less';
import AppHeaderButton from '@/components/_common/AppHeaderButton';
import { useWindowSize } from '@/hooks';
import { useHelpConfig } from '@/core/domain/helpcenter/HelpConfig/HelpConfig.hooks';
import { isAppPortocar } from '@/index';

const { Header } = Layout;

function TitleBar() {
  const { isMobile, width } = useWindowSize();
  const { data: helpConfigData } = useHelpConfig();

  const menu = (
    <Menu
      items={[
        {
          label: helpConfigData?.contact,
          key: 'phone',
          icon: <Phone />,
          onClick: () =>
            window.open(`tel:+${helpConfigData?.contact}`, '_blank'),
        },
        {
          label: 'Facebook',
          key: 'facebook',
          icon: <Facebook />,
          onClick: () =>
            window.open('https://facebook.com/UltracarLtda/', '_blank'),
        },
        {
          label: 'Instagram',
          key: 'instagram',
          icon: <Instagram />,
          onClick: () =>
            window.open('https://www.instagram.com/ultracarltda/', '_blank'),
        },
        {
          label: 'Youtube',
          key: 'youtube',
          icon: <Youtube />,
          onClick: () =>
            window.open(
              'https://www.youtube.com/@ultracargestao/videos',
              '_blank',
            ),
        },
      ]}
    />
  );

  return (
    <Header className="help-center-header">
      <div className="help-center-header-content">
        <Link to="/app/dashboard">
          {isMobile ? (
            <div className="logoMin">
              <img
                className="image"
                src={
                  isAppPortocar
                    ? '/images/Logo_PortoCar_branca-icon.svg'
                    : logoMin
                }
                alt="logo"
                style={{ width: '60px' }}
              />
            </div>
          ) : (
            <div className="logo">
              <img
                className="image"
                src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
                alt="logo"
              />
            </div>
          )}
        </Link>

        <Link to="/helpCenter" className="page-title">
          <FormattedMessage id="helpCenter" />
        </Link>

        {isMobile ? (
          <>
            <Dropdown overlay={menu} trigger={['click']}>
              <div className="icons" style={{ margin: 'auto 0' }}>
                <List color="white" />
              </div>
            </Dropdown>
          </>
        ) : (
          <div className="icons">
            <a
              href={`tel:+55${helpConfigData?.contact}`}
              style={{ color: 'white' }}
            >
              <AppHeaderButton icon={<Phone />}>
                {width > 834 && (
                  <span style={{ marginLeft: '8px', fontWeight: 'bold' }}>
                    {helpConfigData?.contact}
                  </span>
                )}
              </AppHeaderButton>
            </a>

            <a
              href="https://facebook.com/UltracarLtda/"
              target="_blank"
              rel="noreferrer"
            >
              <AppHeaderButton icon={<Facebook />} />
            </a>

            <a
              href="https://www.instagram.com/ultracarltda/"
              target="_blank"
              rel="noreferrer"
            >
              <AppHeaderButton icon={<Instagram />} />
            </a>

            <a
              href="https://www.youtube.com/@ultracargestao/videos"
              target="_blank"
              rel="noreferrer"
            >
              <AppHeaderButton icon={<Youtube />} />
            </a>
          </div>
        )}
      </div>
    </Header>
  );
}

export default TitleBar;
